const forms = document.querySelectorAll(".bulk-order-form");
forms.forEach((form) => {
  if (form) {
    const inputs = form.querySelectorAll(".quantity__input");
    const buttons = form.querySelectorAll(".quantity__button");
    const error = form.querySelector(".bulk-order-form-error");
    const submitButton = form.querySelector(".bulk-order-form-button");

    function checkInputs() {
      const disabled = Array.from(inputs).every((input) => {
        const value = input.value.trim();
        return value === "" || value === "0";
      });
      submitButton.disabled = disabled;
      const event = new Event("change");
      inputs.forEach((input) => {
        input.dispatchEvent(event);
      });
    }

    function minusButtonDisabled(input) {
      const parent = input.closest('.quantity');
      const minusButton = parent.querySelector('[name="minus"]');
      if (input.value == '' || input.value == 0) {
        minusButton.classList.add('disabled');
      } else {
        minusButton.classList.remove('disabled');
      }
    }

    const bulkInputs = Array.from(inputs);
    bulkInputs.forEach((input) => {
      minusButtonDisabled(input);
      input.addEventListener("input", checkInputs);
      var max = parseInt(input.getAttribute("max"));
      input.addEventListener("change", function () {
        minusButtonDisabled(input);
        if (input.value > max) {
          input.parentNode.classList.add("is-over");
          input.dataset.error = "true";
        } else {
          input.parentNode.classList.remove("is-over");
          input.dataset.error = "false";
        }
        if (input.value == 0) {
          input.parentNode.classList.remove("is-true");
        } else {
          input.parentNode.classList.add("is-true");
        }
        const hasErrors = Array.from(inputs).some(
          (input) => input.dataset.error === "true"
        );
        if (hasErrors) {
          submitButton.classList.add("is-disabled");
          error.hidden = false;
        } else {
          submitButton.classList.remove("is-disabled");
          error.hidden = true;
        }
      });
    });
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        setTimeout(checkInputs, 0);
      });
    });
    submitButton.addEventListener("click", (event) => {
      event.preventDefault();
      let formData = {
        items: [],
      };
      let inputElements = form.querySelectorAll(".quantity__input");
      inputElements.forEach(function (inputElement) {
        let quantity = parseInt(inputElement.value);
        if (quantity > 0) {
          let variantId = inputElement.getAttribute("name");
          formData.items.push({
            id: variantId,
            quantity: quantity,
          });
        }
      });
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }
});
